<template>
  <label :class="labelclass" @click="show = !show">
    <span
      v-tooltip.bottom="{
        
        showDelay: 1000,
        hideDelay: 300,
      }"
    >{{ labelvalue }}</span>
    <span v-if="isRequiredLabel">*</span>
    <i
      v-if="isRequiredTooltipIcon"
      class="icon l-shared ml-1"
      v-tooltip.bottom="{
        value: tooltipvalue,
        showDelay: 1000,
        hideDelay: 300,
      }"
    ></i>
    <br v-if="labelvaluesmall !== '' && labelvaluesmall !== null" />
    <small v-if="labelvaluesmall !== '' && labelvaluesmall !== null">{{ labelvaluesmall }}</small>
  </label>
</template>

<script>
export default {
  props: {
    labelvalue: {
      type: [String,Number,Boolean],
      default: ""
    },
    labelvaluesmall: {
      type: String,
      default: ""
    },
    labelclass: {
      type: String,
      default: ""
    },
    labelfor: {
      type: String,
      default: ""
    },
    tooltipvalue: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    isRequiredLabel: {
      type: Boolean,
      default: false
    },
    isRequiredTooltipIcon: {
      type: Boolean,
      default: false
    },
    smalltextnewline: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false
    };
  },
  mounted() {
    let _this = this;
    window.addEventListener("mousedown", function() {
      _this.show = false;
    });
  }
};
</script>

<style scoped>
.icon {
  display: inline-block;
  margin-bottom: -3px !important;
}
</style>
